export const css = {
    root: '_3S21fD3l',
    title: '_2fsprQbj',
    ' _key': 'book-widgets/topicset'
};
export default css;
